// QuillEditor.js
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ContentToolbar from './ContentToolbar';

const QuillEditor = ({
  value,
  onChange,
  disabled,
  index = 0,
  isContentChange,
  setContentChange,
  setIsChangeValue,
}) => {
  // Usamos un estado interno para manejar el valor que se muestra
  const [editorValue, setEditorValue] = useState(value || '');

  // Sincronizamos el estado interno cuando se actualiza el valor pasado desde el Form.Item
  useEffect(() => {
    setEditorValue(value || '');
  }, [value]);

  const handleChange = (content, delta, source, editor) => {
    const html = editor.getHTML();
    setEditorValue(html);
    onChange(html);
    setContentChange(true);
    setIsChangeValue(true);
  };

  return (
    <>
      <ContentToolbar isChangeValue={isContentChange} index={index} />
      <ReactQuill
        className='resource-form-admin-input-content'
        modules={{
          toolbar: `#toolbar-module-input-row-${index}`,
        }}
        theme='snow'
        value={editorValue}
        onChange={handleChange}
        readOnly={disabled}
      />
    </>
  );
};

export default QuillEditor;
